import { BrandingImage, BrandingStyle, useModel } from "@bcm-dev/bcms-vite";
import PageLayoutContainer from "components/shared/containers/PageLayoutContainer";
import PageFooterView from "components/shared/views/PageFooterView";
import PageHeaderView, { MobilePageHeaderView } from "components/shared/views/PageHeaderView";
import React from "react";
import { ImageAsset } from "res";
import MainNavView from "../MainNavView";
import UtilityNavView from "../UtilityNavView";
import "./styles.css";
import "./mobile.css";


/**
 * @function PageContentView
 * @param {React.Component} children - Content that's contained in this page.
 * @returns {React.Component}
 * @example
 * <PageContentView>
 *  <LeftColumn />
 *  <RightColumn />
 * </PageContentView>
 */
export default function PageContentView(props) {
  const showHeader = props.showHeader ?? true;
  const hidePageBody = props.hidePageBody ?? false;
  const { branding } = useModel();
  const { options } = branding;
  const fdicLogoUnderFILogoType = options.fdic_fi_logo_abi22;
  const hasFDICLogoUnderFILogo = fdicLogoUnderFILogoType !== "undefined" && fdicLogoUnderFILogoType !== "None";
  let fdicImageID = "FDICDigitalSignWhite";
  if(fdicLogoUnderFILogoType === "Colored (White BG)") fdicImageID = "FDICDigitalSign";

  return (
    <BrandingStyle style={ hidePageBody ? {} : { "backgroundImage":"url([[main_bg_image_abi22]])" } } className="page-content-view flex-container flex-vertical" >
      { showHeader && 
      <>
        <PageHeaderView>
          <div className={`upper-header-wrapper flex-container flex-horizontal align-center
            ${ hasFDICLogoUnderFILogo ? "fdic-logo-adjusted" : ""}`}>
            <div className={ `flex-width logo-container ${ hasFDICLogoUnderFILogo ? "fdic-logo-adjusted" : ""}`}>
              { !hasFDICLogoUnderFILogo && 
              <a href="#/accountSummary">
                <BrandingImage id="header_logo_abi22" className="page-header-logo" />
              </a>
              }
              { hasFDICLogoUnderFILogo &&
              <div className="flex-container flex-vertical">
                <a href="#/accountSummary">
                  <BrandingImage id="header_logo_abi22" className="page-header-logo fdic-logo-adjusted" />
                </a>
              </div> 
              }
            </div>
            <UtilityNavView/>
          </div>
          { hasFDICLogoUnderFILogo &&
            <div className="fdic-logo-container">
              <ImageAsset id={ fdicImageID } className={ "fdic-logo" } />
            </div> 
            }
          <MainNavView/>
        </PageHeaderView>
        <MobilePageHeaderView />
        {/* The fdic logo is shown beneath the header view in mobile view. */}
        { hasFDICLogoUnderFILogo &&
        <div className="fdic-logo-container show-on-mobile">
          <ImageAsset id={ fdicImageID } className={ "fdic-logo" } />
        </div>
        }
      </>
      }
      <PageLayoutContainer className={ hidePageBody ? "visibility-hidden" : "" }>
        {props.children}
      </PageLayoutContainer>
      { !hidePageBody && <PageFooterView /> }
      
    </BrandingStyle>
  );
}